// 需重整是否可以統一 import 方式，避免重複？

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Cookies from "js-cookie";
// import axios from "axios";
// import "jquery";
import "bootstrap";
import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

// Install axios and BootstrapVue
// Vue.prototype.$axios = axios;
// Vue.prototype.$ = $;
Vue.use(BootstrapVue);

// 編輯器
import CKEditor from "ckeditor4-vue";
Vue.use(CKEditor);

import "./plugins/dayjs";

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  created() {
    const token = Cookies.get("chuenStock");
    const userInfoString = Cookies.get("chuenStock_loggedInInfo");
    if (token && userInfoString) {
      const loggedInInfo = JSON.parse(userInfoString);
      Cookies.set("chuenStock", token);
      this.$store.commit("loggedInInfo", loggedInInfo);
    }
  },
  render: h => h(App)
}).$mount("#app");
